import { render, staticRenderFns } from "./Tutar.vue?vue&type=template&id=473e69bc"
import script from "./Tutar.vue?vue&type=script&lang=ts"
export * from "./Tutar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports